<template>
<div>
    <div class="date-time-pick" >   
        <div style="flex:1;" @click="setError">
            <VueCtkDateTimePicker
            v-model="initial_date"
            label="Select Date"
            color="#ee2d24" 
            :min-date="min_date"
            :disabled-dates="disabledDate"
            :disabled-weekly="disabledWeekly"
            no-button-now
            format='YYYY-MM-DD'
            formatted='ll'
            onlyDate
            @validate="pickDate"
            :error="isError"
            />
        </div> 
        <div style="flex:1">
        <v-select
            item-color="green"
            :error="isError"
            v-model="initial_hour"
            :items="businessTime"
            dense
            outlined
            suffix="Select Time"
            flat
            class="time-available-picker"
            @change="pickDateTime"
            placeholder="select time"
        ></v-select>
    </div>

</div>
</div>  


</template>
<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import { validateBusinessAndHoliday} from '@/api/api'
import moment from 'moment';
import { mainMixin} from '@/mixins/mainMixin'
import { CollapseItem } from 'vant';

export default {
    name: 'DateTimePicker',
    components: {
        VueCtkDateTimePicker
    },
    props: {
        businessHours: {
            type: Object,
        },
        holiday: {
            type: Object,
        },
        minDate: {
            type: Date,
        },
        date: {
            type: Date
        },
        confirm: {
            type: Function
        },
        evtEnabledButtonCheckout:{
            type: Function
        },
        isShowtimeSchedule:{
            type:Boolean,
            default:false,
        }
    },
    data () {
    return {
        savedDate: null,
        isError:false,
        initial_date:null,
        initial_hour:null,
        min_date:'',
        min_hour:'',
        max_date:'',
        store: {},
        disabledMinHour:[],
        disabledPickedHour: [],
        disabledDate:[],
        disabledHour:[],
        holidayDate:[],
        disabledDays:[],
        disabledWeekly:[],
        businessTime: [],
        }
    },
    mixins: [mainMixin],
    mounted() {
        if (sessionStorage.getItem('select_time')) {
            let save_date= new Date(sessionStorage.getItem('select_time'))
            let curr_dateTime = new Date()

            let select_time = save_date.getTime()
            let currTime = curr_dateTime.getTime()
            let diff_Time = (select_time - currTime ) / 1000 / 60;

            console.log('select time', select_time)
            console.log('current time', currTime)
            console.log('diff time',diff_Time)
            if( save_date.getTime() >= curr_dateTime.getTime()){
              if(diff_Time >= -10){
                  this.savedDate = save_date
              }else{
                  sessionStorage.removeItem('select_time')
              }
            }else{
                sessionStorage.removeItem('select_time')
            }
        }
    },
    created() {
        setTimeout(()=>{
            this.filterBusinessDate()
            this.filterHoliday();
            this.getDate();
        },10)
    },
    watch: {
      isShowtimeSchedule: function() {
        if(!this.isShowtimeSchedule){
          this.savedDate = null
        }else{
            if(this.savedDate == null)
            sessionStorage.setItem('select_time', this.minDate)
        }
        setTimeout(()=>{
          this.filterBusinessDate()
          this.filterHoliday();
          this.getDate();
        },10)
        
        if(this.businessTime.indexOf(this.initial_hour) !== -1){
            this.evtEnabledButtonCheckout(false)
        }else {
            this.evtEnabledButtonCheckout(true)
        }
      }
    },
    methods: {
        setError(){
            this.$emit("evtSetIndexHigh")
            this.isError = true
        },
        getDate(){
            if(this.savedDate){
                this.initial_date= moment(this.savedDate).format("YYYY-MM-DD")
            }else{
                this.initial_date=moment(this.date).format("YYYY-MM-DD")
            }
            this.getminDateAfterValidate()
            this.getHour()
        },
        getHour(){
            if(this.savedDate){
                this.initial_hour=moment(this.savedDate).format("LT")
                setTimeout(() =>{
                    const parseTime = moment(this.initial_hour,["h:mm A"]).format("HH:mm:ss")
                    let pickedDateTime = this.initial_date+' '+parseTime
                    let chosenDateTime = new Date(Date.parse(moment(pickedDateTime).format('llll')))
                    console.log('chosen saved datetime', chosenDateTime)

                    let currentDateTime = new Date();
                    let currentTime = currentDateTime.getTime()
                    let dishtime = chosenDateTime.getTime()
                    let ftime = (dishtime - currentTime) / 1000 / 60;
                    // console.log('ftime',ftime)

                    this.isError = false
                    this.confirm(chosenDateTime);
                    if(this.businessTime.indexOf(this.initial_hour) !== -1){
                        if(ftime > -10){
                            this.evtEnabledButtonCheckout(false)
                        }else{
                            this.evtEnabledButtonCheckout(true)
                        }
                    }else {
                        this.evtEnabledButtonCheckout(true)
                    }
                },1000)
            }else{
                this.initial_hour=moment(this.date).format("LT")
                if(this.isShowtimeSchedule){
                    if(this.businessTime.indexOf(this.initial_hour) !== -1){
                            this.evtEnabledButtonCheckout(false)
                    }else{
                        this.evtEnabledButtonCheckout(true)
                    }
                }
                console.log('initial hour',this.initial_hour)
            }
        },
        getminDateAfterValidate(){
            console.log('minDate After Validate', this.minDate)
            // let current_date = this.minDate
            // let format_current_date = moment(current_date).format("dddd").toUpperCase()
            this.getMinDate()
        },
        getMinDate(){
            let date= {} ;
            if(this.savedDate){
                date = this.savedDate
            }else{
                date = this.minDate
            }

            let formatDate = moment(this.minDate).format("YYYY-MM-DD HH:mm")
            let formatDay = moment(date).format("dddd").toUpperCase()
            // console.log('formatWeekDay',formatDay)
            this.min_date = formatDate
            let formatHour = moment(this.minDate).format("LT")
            this.min_hour = formatHour
            this.filterBusinessHour(formatDay,date)
        },
        pickDate() {
            this.$emit("evtSetIndexZero")
            let new_date= new Date(this.initial_date)
            let days = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY']
            let pick_day= days[new_date.getDay()]
            this.filterBusinessHour(pick_day,this.initial_date)
            this.pickDateTime()
            
        },
        pickDateTime() {
            // console.log('pick time =>>',this.initial_hour)
            // console.log('pick date =>>',this.initial_date)
            
            const parseTime = moment(this.initial_hour,["h:mm A"]).format("HH:mm:ss")
            let pickedDateTime = this.initial_date+' '+parseTime
            let chosenDateTime = new Date(Date.parse(moment(pickedDateTime).format('llll')))

            sessionStorage.setItem('select_time', chosenDateTime);
            console.log('chosen datetime', chosenDateTime)

            let currentDateTime = new Date();
            let currentTime = currentDateTime.getTime()
            let dishtime = chosenDateTime.getTime()
            let ftime = (dishtime - currentTime) / 1000 / 60;
            
            if(this.initial_date == null){
                this.$toast("No date chosen, please select a date")
            }else if(this.initial_hour == null){
                this.$toast("No time chosen, please select the time")
            }else if(currentDateTime.getDate() == chosenDateTime .getDate() && ftime < -10){
                this.$toast("Time is not available!")
                this.evtEnabledButtonCheckout(true)
            }
            else{
                if(this.businessTime.indexOf(this.initial_hour) !== -1){
                    this.evtEnabledButtonCheckout(false)
                    this.isError = false
                    this.confirm(chosenDateTime);
                }else {
                    this.evtEnabledButtonCheckout(true)
                }  
            }
        },
        filterHoliday(){
            let holiday_date = []
            let holiday = this.holiday.data
            holiday.forEach(element =>{
                let holidays_event_array = Object.values(element)[0]
                holidays_event_array.forEach(data=>{
                    holiday_date.push(data.date)
                })
            })
            this.holidayDate= holiday_date
            this.filterDisabledDate()
        },
        filterBusinessDate(){
            let businesshours = this.businessHours.data
            let businessDaysArray = []
            let daysOpen=[]
            let days = ['SUNDAY','MONDAY','TUESDAY','WEDNESDAY','THURSDAY','FRIDAY','SATURDAY']

            businesshours.forEach(el =>{
                const business_value_key= Object.values(el)[0]
                const business_object_key= Object.keys(el)
                business_value_key.forEach(data =>{
                    const doc = Object.assign({}, {
                        day: business_object_key[0]
                    })
                    businessDaysArray.push(doc)
                })
            })
            businessDaysArray.map(data=>(
                daysOpen.push(data.day)
            ))
            for(let i=0; i<daysOpen.length; i++){
                days= days.filter(item => item !== daysOpen[i])
            }
            let closeDays= days
            let closeDaysIndex =[]

            closeDays.forEach(el =>{
                if (el == 'SUNDAY'){
                    closeDaysIndex.push(0)
                } else if (el == 'MONDAY'){
                    closeDaysIndex.push(1)
                } else if (el== 'TUESDAY'){
                    closeDaysIndex.push(2)
                } else if (el == 'WEDNESDAY'){
                    closeDaysIndex.push(3)
                } else if (el == 'THURSDAY'){
                    closeDaysIndex.push(4)
                } else if (el == 'FRIDAY'){
                    closeDaysIndex.push(5)
                } else if (el == 'SATURDAY'){
                    closeDaysIndex.push(6)
                }
            })
            // console.log('index closed day',closeDaysIndex)
            this.disabledWeekly =closeDaysIndex
        },  

        filterBusinessHour(pick_day,date){
            let businesshours = this.businessHours.data
            let hours = ['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24']
            let businessHourArray = []
            let business_hour= []
            let business_time = []

            const convertAmPm= (time) => {
                const convert_time = JSON.stringify(time).padStart(4, '0').slice(0,2)
                let suffix = (convert_time) >= 12 ? ' PM': ' AM'
                let hours = (parseInt(convert_time) % 12) || 12;

                let minutes = JSON.stringify(time).padStart(4, '0').slice(2,4)
                return hours + ":" + (minutes.padStart(2, '0') || '00') + suffix
            }

            businesshours.forEach(el =>{
                const business_value_key= Object.values(el)[0]
                const business_object_key= Object.keys(el)

                business_value_key.forEach(data =>{
                    const doc = Object.assign({}, {
                        day: business_object_key[0],
                        id: data.id,
                        start: data.start,
                        end:data.end,
                        full_day: data.isFullDay
                    })
                    businessHourArray.push(doc)
                })
            })

            for( const item of businessHourArray){
                if(item.day == pick_day){
                    let startBusiness = item.start.toString().padStart(4,"0")
                    let endBusiness = item.end.toString().padStart(4,"0")
                    let hourStartBusiness = Number(startBusiness.substring(0,2))
                    let hourEndBusiness = Number(endBusiness.substring(0,2))

                    business_time.push(parseInt(startBusiness))
                    business_time.push(parseInt(endBusiness))
                    for(let i=parseInt(startBusiness); i<parseInt(endBusiness); i = i+10){
                        let mins = i % 100 ;
                        let minsRoundUp = Math.floor(mins / 10) * 10 ;
                        let hours = parseInt(i/100)
                        
                        i = parseInt(hours + '' + minsRoundUp)
                        if(mins >59){
                            mins = 0;
                            hours +=1;
                            i = hours * 100;
                        }
                        if( i >= parseInt(startBusiness) && i<= parseInt(endBusiness)){
                            business_time.push(i)
                            
                        }
                    }

                    for( let i=hourStartBusiness; i<=hourEndBusiness; i++){
                        let doc = i.toString().padStart(2,"0")
                        business_hour.push(doc)
                    }
                }
            }

            let sorting_business_time= business_time.sort(function(a, b){return a - b})
            console.log('sort time', sorting_business_time)
            
            let x= [];
            let currDate = moment(new Date()).format("YYYY-MM-DD")
            let todayDate = moment(date).format("YYYY-MM-DD")
            // console.log('currDate',currDate)
            // console.log('todaydate', todayDate)
            // console.log(this.format24Hour(new Date()))
            if( todayDate == currDate){
                x= sorting_business_time.filter(time => {
                    return time >= this.format24Hour(new Date()) 
                })
                console.log('today available time',x)
            }else{
                x = sorting_business_time
            }
            let chars =  x.map( data =>  convertAmPm(data))
            this.businessTime  = [...new Set(chars)]

            // console.log('available time',this.businessTime)
        },

        filterDisabledDate(){
            let array = this.holidayDate.concat(this.disabledDays)
            let uniqueDate = [...new Set(array)]
            console.log('date disabled', uniqueDate)
            this.disabledDate = uniqueDate
        },
        format24Hour(date) {
            var hours = date.getHours();
            var minutes = date.getMinutes();
            
            var strTime = hours + '' + minutes.toString().padStart(2, "0") ;
            return parseInt(strTime - 9); // minus 9 min before current time
        }
    }
}
</script>
<style  lang="less">
@import url('../../assets/css/common.less');

    .time-available-picker{
        .v-input{
            margin: 0 !important;
            padding: 0 !important;
        }
        .v-input__slot{
            margin: 0 !important;
            padding: 0 0 0 10px !important;
            min-height: 43px !important;
            background-color: @fff !important;
        }

        .v-text-field__details{
            display: none !important;
        }
        .v-text-field__suffix{
            position: absolute;
            top: 2px;
            font-size: 11px !important;
            color: rgb(119, 119, 119) !important;
            font-family: Roboto,-apple-system,BlinkMacSystemFont,Segoe UI,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif !important;
            
        }
        .v-select__selection, .v-select__selection--comma{
            font-size:14px !important;
            font-family: Roboto,-apple-system,BlinkMacSystemFont,Segoe UI,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif !important;
            margin: 10px 0 0 !important;
            padding: 0 !important;
        }
        .v-select__selections{
            padding: 0 !important;
            height: 25px !important;
            margin-left: 3px  !important;

            input{
                margin-top: 10px !important;
                padding: 0 !important;
                color: black !important;
                min-width: 120px !important;
                font-size: 12px !important;
            }
        }
        .v-text-field--outlined ,fieldset{
            border-width: 1px !important;
            border-color: @white13 !important;
        }
    }

    .date-time-pick{
        display: flex;
        align-items: center;

    }

</style>